var brand = "Brand",
  model = "Model",
  version = "Version",
  year = "Year";
function translateText() {
  "et" === Shopify.locale
    ? ((brand = "Tootja"),
      (model = "Mudel"),
      (version = "Versioon"),
      (year = "Aasta"))
    : ((brand = "Brand"),
      (model = "Model"),
      (version = "Version"),
      (year = "Year"));
}
function getSprintCarData() {
  return fetch(
    "https://cdn.shopify.com/s/files/1/0821/7968/6739/files/sprintFilterCarModels.json"
  )
    .then(function (response) {
      if (!response.ok) {
        throw new Error("HTTP error! Status: " + response.status);
      }
      return response.json();
    })
    .catch(function (error) {
      console.error("Error fetching car data: ", error);
      throw new Error("Error fetching car data: " + error);
    });
}

function manualSort(sprintCarData) {
  for (var i = 0; i < sprintCarData.length - 1; i++) {
    for (var j = i + 1; j < sprintCarData.length; j++) {
      if (sprintCarData[i].brand > sprintCarData[j].brand) {
        var temp = sprintCarData[i];
        sprintCarData[i] = sprintCarData[j];
        sprintCarData[j] = temp;
      }
    }
  }
}

function findBrandByName(sprintCarData, brandName) {
  for (var i = 0; i < sprintCarData.length; i++) {
    if (sprintCarData[i].brand === brandName) {
      return sprintCarData[i];
    }
  }
  return null; // If brandName is not found
}

function findModelByName(brandData, modelName) {
  if (!brandData || !brandData.models) {
    return null;
  }
  for (var i = 0; i < brandData.models.length; i++) {
    if (brandData.models[i].model === modelName) {
      return brandData.models[i];
    }
  }
  return null; // If modelName is not found
}

function findVersionByName(modelData, versionName) {
  if (!modelData || !modelData.versions) {
    return null;
  }
  for (var i = 0; i < modelData.versions.length; i++) {
    if (modelData.versions[i].version === versionName) {
      return modelData.versions[i];
    }
  }

  return null; // If versionName is not found
}

function findYearByName(versionData, year) {
  if (!versionData || !versionData.extra.year) {
    return null;
  }
  if (versionData.extra.year === year) {
    return versionData.extra.year;
  }
  return null; // If year is not found
}

function populateOptions() {
  try {
    getSprintCarData().then(function (sprintCarData) {
      var brandSelect = document.getElementById("sprint_brand");
      var modelSelect = document.getElementById("sprint_model");
      var versionSelect = document.getElementById("sprint_version");
      var yearSelect = document.getElementById("sprint_year");

      manualSort(sprintCarData);

      for (var i = 0; i < sprintCarData.length; i++) {
        var brand = sprintCarData[i].brand;
        var option = document.createElement("option");
        option.text = brand;
        option.value = brand;
        brandSelect.add(option);
      }

      modelSelect.disabled = true;
      versionSelect.disabled = true;
      yearSelect.disabled = true;

      var existingSearchBrand = getFromLocalStorage(brandSelect.id);
      var existingSearchModel = getFromLocalStorage(modelSelect.id);
      var existingSearchVersion = getFromLocalStorage(versionSelect.id);
      var existingSearchYear = getFromLocalStorage(yearSelect.id);

      brandSelect.addEventListener("change", function () {
        translateText();
        var selectedBrand = brandSelect.value;
        if (selectedBrand) {
          modelSelect.disabled = true;
          versionSelect.disabled = true;
          yearSelect.disabled = true;
          modelSelect.disabled = false;
          var selectedBrandData = findBrandByName(sprintCarData, selectedBrand);
          modelSelect.innerHTML =
            "<option value='' disabled selected>" + model + "</option>";
          versionSelect.innerHTML =
            "<option value='' disabled selected>" + version + "</option>";
          yearSelect.innerHTML =
            "<option value='' disabled selected>" + year + "</option>";
          if (selectedBrandData && selectedBrandData.models) {
            var sortedModels = selectedBrandData.models.map(function (item) {
              return item.model;
            });
            sortedModels.sort(function (a, b) {
              return a.localeCompare(b);
            });
            sortedModels.forEach(function (model) {
              var option = document.createElement("option");
              option.text = model;
              option.value = model;
              modelSelect.add(option);
            });
          } else {
            modelSelect.disabled = true;
          }
        } else {
          modelSelect.disabled = true;
          versionSelect.disabled = true;
          yearSelect.disabled = true;
        }
      });

      modelSelect.addEventListener("change", function () {
        translateText();
        var selectedModel = modelSelect.value;
        if (selectedModel) {
          versionSelect.disabled = true;
          yearSelect.disabled = true;
          versionSelect.disabled = false;
          var selectedBrandData = findBrandByName(
            sprintCarData,
            brandSelect.value
          );
          var selectedModelData = findModelByName(
            selectedBrandData,
            selectedModel
          );
          versionSelect.innerHTML =
            "<option value='' disabled selected>" + version + "</option>";
          yearSelect.innerHTML =
            "<option value='' disabled selected>" + year + "</option>";
          if (selectedModelData && selectedModelData.versions) {
            var sortedVersions = selectedModelData.versions.map(function (
              item
            ) {
              return item.version;
            });
            sortedVersions.sort(function (a, b) {
              return a.localeCompare(b);
            });
            sortedVersions.forEach(function (version) {
              var option = document.createElement("option");
              option.text = version;
              option.value = version;
              versionSelect.add(option);
            });
          } else {
            versionSelect.disabled = true;
          }
        } else {
          versionSelect.disabled = true;
          yearSelect.disabled = true;
        }
      });

      versionSelect.addEventListener("change", function () {
        translateText();
        var selectedVersion = versionSelect.value;
        if (selectedVersion) {
          yearSelect.disabled = true;
          yearSelect.disabled = false;
          var selectedBrandData = findBrandByName(
            sprintCarData,
            brandSelect.value
          );
          var selectedModelData = findModelByName(
            selectedBrandData,
            modelSelect.value
          );
          var selectedVersionData = findVersionByName(
            selectedModelData,
            selectedVersion
          );
          yearSelect.innerHTML =
            "<option value='' disabled selected>" + year + "</option>";

          if (selectedVersionData && selectedVersionData.years) {
            var sortedYears = selectedVersionData.years.map(function (item) {
              return item.year;
            });
            sortedYears.sort(function (a, b) {
              return a.localeCompare(b);
            });
            sortedYears.forEach(function (year) {
              var option = document.createElement("option");
              option.text = year;
              option.value = year;
              yearSelect.add(option);
            });
          } else {
            yearSelect.disabled = true;
          }
        } else {
          yearSelect.disabled = true;
        }
      });

      if (containsPathSegment(window.location.href, "search")) {
        if (
          existingSearchBrand != null &&
          findBrandByName(sprintCarData, existingSearchBrand) != null
        ) {
          brandSelect.value = existingSearchBrand;

          var evt = document.createEvent("HTMLEvents");
          evt.initEvent("change", false, true);
          brandSelect.dispatchEvent(evt);
        }

        if (existingSearchModel != null) {
          modelSelect.value = existingSearchModel;

          var evt = document.createEvent("HTMLEvents");
          evt.initEvent("change", false, true);
          modelSelect.dispatchEvent(evt);
        }

        if (existingSearchVersion != null) {
          versionSelect.value = existingSearchVersion;

          var evt = document.createEvent("HTMLEvents");
          evt.initEvent("change", false, true);
          versionSelect.dispatchEvent(evt);
        }
        if (existingSearchYear != null) {
          yearSelect.value = existingSearchYear;

          var evt = document.createEvent("HTMLEvents");
          evt.initEvent("change", false, true);
          yearSelect.dispatchEvent(evt);
        }
      }
    });
  } catch (error) {
    console.error("Error populating car data: ", error);
    throw new Error("Error populating car data: " + error);
  }
}

populateOptions();

function getFromLocalStorage(key) {
  return localStorage.getItem(key);
}

function containsPathSegment(urlString, segment) {
  try {
    const url = new URL(urlString);
    const pathname = url.pathname;

    return pathname.includes(segment);
  } catch (error) {
    return false;
  }
}
